
<template>
  <v-dialog     scrollable persistent v-model="accounts.modals.meneger" width="900"   >
  <v-card  >
    <v-toolbar dark  color="#4A76A8" flat  height="42">
      <v-toolbar-title  >  Логины и пароли  </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon @click="accounts.modals.meneger = false">mdi-close</v-icon>
    </v-toolbar>

  <v-card-text>


    <v-tabs  height="25"    >
   <v-tab active-class="tabs"    @click="changeMode(item.itemName) "
      v-for="item of init.bar.items"
      :key="item.itemName"
   >
    <v-icon left  :color="item.color">mdi-{{item.icon}}</v-icon>
    <span style="margin-left:5px"> {{item.text}} {{item.acc.length}}  </span>
   </v-tab>
  </v-tabs>


  <div style="height:5px"></div>
  <v-layout justify-space-between>




  <div style="width:880px">




  <v-textarea   height="350"   color="#4A76A8" readonly
  v-model="init.selectedList"
  box
  label="Список аккаунтов"
  >

  </v-textarea>


  <v-layout v-show="false">
  <v-btn disabled  @click="deleteAll()"    block color="red" class="white--text" ><v-icon left>mdi-delete</v-icon> Удалить {{init.bar.items[init.selectedTabN].text}} {{sortAcc}}</v-btn>
  <div style="width:10px"></div>
  </v-layout>

  </div>





  </v-layout>
  </v-card-text>

  </v-card>
  </v-dialog>
</template>

<script>

import axios from 'axios'

export default {

props:['accounts'],
  data () {
    return {
      init:{
        selectedList: '',
        selectedTab: 'all',
        selectedTabN: 0,
        bar: {
          items: [
            {
              itemName: "all",
              text: "Все аккаунты",
              acc: [],
              list: "",
              icon: "all-inclusive",
              color: "primary",
            },
            {
              itemName: "valid",
              text: "Валидные",
              acc: [],
              list: "",
              icon: "account-check",
              color: "primary",
            },
            {
              itemName: "selected",
              text: "Выбранные",
              acc: [],
              list: "",
              icon: "selection-drag",
              color: "primary",
            },
            {
              itemName: "novalid",
              text: "Невалидные",
              acc: [],
              list: "",
              icon: "account-check",
              color: "red",
            },
            {
              itemName: "tokens",
              text: "Токены",
              acc: [],
              list: "",
              icon: "account-check",
              color: "primary",
            },

          ],
        },
      },
  }
},
methods:{


  updateAccounts: function(){
  if(this.accounts.accGroups.list.length < 1)  {this.accounts.loader = true}
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/accounts_get.php', {
       contentType: 'JSONP',
       method: 'get',
       params: {
         grId: this.accounts.accGroups.selectedGr.gr_id,
       }
       }).then(response => {
   this.accounts.loader = false
   if(response.data ){
     this.accounts.accGroups.list = response.data
   } else {
     this.accounts.accGroups.list = []
   }
   this.accounts.loader = false
       })

  },




  deleterAll(id){
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/accounts_delete.php', {
         method: 'POST',
         data: {
           id: id
         }
       }).then(response => {
         this.updateAccounts()
       })
  },

  changeMode(itemName){

     if(itemName == 'all'){
       this.init.selectedList = this.init.bar.items[0].list
       this.init.selectedTab = itemName
       this.init.selectedTabN = 0
     }
     if(itemName == 'valid'){
       this.init.selectedList = this.init.bar.items[1].list
       this.init.selectedTab = itemName
       this.init.selectedTabN = 1
     }
     if(itemName == 'selected'){
       this.init.selectedList = this.init.bar.items[2].list
       this.init.selectedTab = itemName
       this.init.selectedTabN = 2
     }
     if(itemName == 'novalid'){
       this.init.selectedList = this.init.bar.items[3].list
       this.init.selectedTab = itemName
       this.init.selectedTabN = 3
     }
     if(itemName == 'tokens'){
       this.init.selectedList = this.init.bar.items[4].list
       this.init.selectedTab = itemName
       this.init.selectedTabN = 4
     }
  },

  deleteAll(){
    if(this.init.selectedTab == 'all'){
        this.init.bar.items[0].acc.forEach((item,i,arr)=>{
          this.deleterAll(item.id)
        })
       this.accounts.accGroups.list = []
       this.accounts.modals.meneger = false


    }
    if(this.init.selectedTab == 'valid'){
      this.init.selectedList = null
      this.init.bar.items[1].acc.forEach((item,i,arr)=>{
        this.deleterAll(item.id)
      })
      this.accounts.modals.meneger = false


    }
    if(this.init.selectedTab == 'selected'){

      this.init.bar.items[2].acc.forEach((item,i,arr)=>{
      this.deleterAll(item.id)
      })

        this.accounts.modals.meneger = false
        //this.accounts.accGroups.list = []
        //this.accounts.loader = true


    }


    if(this.init.selectedTab == 'novalid'){
      this.init.bar.items[3].acc.forEach((item,i,arr)=>{
        this.deleterAll(item.id)
      })
     this.init.bar.items[3].acc = []
     this.init.bar.items[0].acc =  this.init.bar.items[1].acc
     this.accounts.accGroups.list = this.init.bar.items[1].acc
     this.init.selectedList = ''
    }

  },
},
computed: {
  disable(){ // не используется временно так как кривая
    if(this.init.bar.items[this.init.selectedTabN].acc.length<1){
      return true
    }
  },
  sortAcc(){
    if( this.accounts.accGroups.list.length>0 ){

    this.init.bar.items[0].list = ''
    this.init.bar.items[1].list = ''
    this.init.bar.items[2].list = ''
    this.init.bar.items[3].list = ''
    this.init.bar.items[4].list = ''

      this.init.bar.items[0].acc =  this.accounts.accGroups.list.filter(
        (item,i,arr)=>{
          return item.info.valid > -1
        }
      )
      this.init.bar.items[0].acc.forEach((item,i,arr)=>{
        this.init.bar.items[0].list += item.info['logian:pass']+'\n'
      })



  this.init.bar.items[1].acc =  this.accounts.accGroups.list.filter(
    (item,i,arr)=>{
      return item.info.valid > 0
    }
  )
  this.init.bar.items[1].acc.forEach((item,i,arr)=>{
    this.init.bar.items[1].list += item.info['logian:pass']+'\n'
  })




  this.init.bar.items[2].acc =  this.accounts.accGroups.list.filter(
    (item,i,arr)=>{
      return item.selected
    }
  )
  this.init.bar.items[2].acc.forEach((item,i,arr)=>{
    this.init.bar.items[2].list += item.info['logian:pass']+'\n'
  })


  this.init.bar.items[3].acc =  this.accounts.accGroups.list.filter(
    (item,i,arr)=>{
      return item.info.valid == 0
    }
  )
this.init.bar.items[3].acc.forEach((item,i,arr)=>{
  this.init.bar.items[3].list += item.info['logian:pass']+":"+item.info['token_api']+'\n'
})


  this.init.bar.items[4].acc =  this.accounts.accGroups.list.filter(
    (item,i,arr)=>{
      return item.info.valid
    }
  )
this.init.bar.items[4].acc.forEach((item,i,arr)=>{
  this.init.bar.items[4].list += item.info['token_api']+'\n'
})



   this.changeMode('all')
   return ''
    }
}
},
created(){
 // console.log(this.accounts)
},



}
</script>

<style   >

</style>
